import React, { useState, useEffect, useRef } from "react";
import queryString from "query-string";
import { CSSTransition } from "react-transition-group";
import { Form, Progress, Alert } from "reactstrap";

import { useLocalization } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';
import logo from './img/logo_fibra.png';

const LoginForm = ({ api, location, TurnstileComponent, ...props }) => {
  const nodeRef = useRef(null);
  const { translate, changeDefaultLocale } = useLocalization();
  changeDefaultLocale('pt-BR');
  const [onLogin, setOnLogin] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [error, setError] = useState({
    open: false,
    message: "",
  });
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const parameters = queryString.parse(location.search);

  useEffect(() => {
    setShowForm(true)
  }, []);

  const onSubmit = async (ev) => {
    ev.preventDefault();
    setOnLogin(true)
    setError({
      open: false,
      message: "",
    })

    api.userPassLogin(
      {
        username,
        password,
        cp_convert: parameters.cp_convert
      },
      parameters
    )
      .then((response) => {
        setOnLogin(false)
        window.location = parameters.redirect_uri + "?" + queryString.stringify(response);
      })
      .catch((error) => {
        const _translate = translate(error.errorCode);
        let message = translate("RequestLoginErrorMessage")
        if (_translate) {
          message = _translate;
        } else if (error.details) {
          message = error.details;
        }
        setOnLogin(false)
        setError({ open: true, message })
      });
  }

  return (
    <CSSTransition
      in={showForm}
      timeout={300}
      classNames="formshow"
      nodeRef={nodeRef}
      unmountOnExit
    >
      <div ref={nodeRef}>
        <Form onSubmit={(event) => onSubmit(event)} className="login">
          <div className="wrapper-netsul fadeInDown">
            <div id="snackbar"></div>
            <div id="formContent-netsul">
              <div className="menu1-netsul">
                <div className="fadeIn first">
                </div>
                <div className="netsul-logo">
                  <img src={logo} alt="netsul" />
                </div>
                <div><p className="detail-netsul">{translate("UserName")}</p></div>
                <input
                  className="fadeIn second"
                  disabled={onLogin}
                  onChange={e => setUsername(e.target.value)}
                  required={true}
                  tabIndex={1}
                  type="text"
                  autoCorrect="off"
                  autoCapitalize="none"
                  name="login"
                  id="login-netsul"
                />
                <div><p className="detail-netsul">{translate("Password")}</p></div>
                <input
                  className="fadeIn third"
                  required={true}
                  disabled={onLogin}
                  onChange={e => setPassword(e.target.value)}
                  tabIndex={1}
                  type="password"
                  autoCorrect="off"
                  autoCapitalize="none"
                  id="password-netsul"
                  name="login"
                >
                </input>
                <div className="buttons-netsul">
                  {!onLogin ? (
                    <button type="submit" className="fadeIn fourth" id="entrar-netsul" disabled={!props.turnstileSuccess} >
                      <span className="entrar-text" id="text">
                        {translate("ButtonEnter")}
                      </span>
                    </button>
                  ) : (
                    <Progress animated color="danger" value={100} />
                  )}
                </div>

                <div className="forgotNetsulText">
                  <a href="https://netsulminas.com.br/recuperarsenha">{translate("ForgotPassword")}</a>
                </div>
                <TurnstileComponent setTurnstileSuccess={props.setTurnstileSuccess} />
                <div className="messages-container">
                  <Alert
                    color="danger"
                    id="error-message"
                    isOpen={error.open}
                    toggle={() => setError({ open: false })}
                  >
                    {error.message}
                  </Alert>
                </div>
              </div>
            </div>
          </div>
        </Form>
      </div>
    </CSSTransition>
  );
}

export default WithCaptcha(LoginForm, { useInsideForm: true, style: { marginTop: '2rem' } });
